import React from 'react';
import { components } from 'react-select';
import { Icon } from '@shopify/polaris';
import { SelectMinor } from '@shopify/polaris-icons';

export const DropdownIndicator = props => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <Icon source={SelectMinor} color="base" />
      </components.DropdownIndicator>
    )
  );
};

export const GroupHeading = props => (
  <div className="BC-select-group-style">
    <components.GroupHeading {...props} />
  </div>
);

export const styles = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    borderColor: state.isFocused ? 'rgba(0,126,98,1) !important' : 'hsl(0,0%,80%)',
    boxShadow: state.isFocused ? '0 0 0 1px rgba(0,126,98,1)' : '',
    height: '36px',
    minHeight: '36px'
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => {
    const color = isDisabled ? '#8C9196' : isSelected ? '#FFF' : '#000';
    return {
      ...styles,
      backgroundColor: isSelected ? 'rgba(0,126,98,1)' : isFocused ? '#F1F8F5' : '#fff',
      color: color,
      padding: '8px'
    };
  },
  menu: baseStyles => ({
    ...baseStyles,
    borderRadius: '8px',
    zIndex: 99
  }),
  menuList: baseStyles => ({
    ...baseStyles,
    padding: '8px'
  }),
  groupHeading: baseStyles => ({
    ...baseStyles,
    flex: '1 1',
    margin: 0
  })
};

export const getStylesCustom = custom => {
  const { option = {}, menu = {} } = custom;
  return {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: state.isFocused ? 'rgba(0,126,98,1) !important' : 'hsl(0,0%,80%)',
      boxShadow: state.isFocused ? '0 0 0 1px rgba(0,126,98,1)' : '',
      height: '36px',
      minHeight: '36px'
    }),
    option: (styles, { isFocused, isSelected }) => {
      return {
        ...styles,
        backgroundColor: isSelected ? 'rgba(0,126,98,1)' : isFocused ? '#F1F8F5' : '#fff',
        color: isSelected ? '#FFF' : '#000',
        ...option
      };
    },
    menu: baseStyles => ({
      ...baseStyles,
      borderRadius: '8px',
      zIndex: 99,
      ...menu
    }),
    menuList: baseStyles => ({
      ...baseStyles,
      padding: '8px'
    })
  };
};
